import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

// Legacy request kept if needed
export const GenerateScriptsRequest = (userId, tempFilePath, scripts) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GenerateScripts`,
	params: { userId, tempFilePath, scripts }
});

// ProcessMocnWork request (FormData for file upload)
export const ProcessMocnWorkRequest = (formData) => {
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/ProcessMocnWork`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

// Generate Audit Report request
export const GenerateAuditReportRequest = () => {
	// Create request with current date
	const auditRequest = {
		currentDate: new Date().toISOString(),
		scriptsOutputFolder: "C:\\temp\\Scripts\\Output"
	};

	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/GenerateAuditSummary`,
		data: auditRequest,
		headers: {
			'Content-Type': 'application/json'
		}
	});
};

// Generate enodebPairing request
export const ProcessEnodebPairingWorkRequest = (formData) => {
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}Scripts/ProcessEnodebPairingWork`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};